import * as React from 'react';
import { Tooltip } from 'components/common';
import { localize } from 'core/localization';
import { Hint } from 'components/common/Hint/Hint';
import ReviewForm from '../ReviewForm';
import { CommentIcon, ReviewWrapper, ToggleButton, ToggleButtonText } from './ReviewSpot.styled';
import { withTheme } from 'styled-components';

type ReviewSpotProps = {
  isGeneral: boolean;
  isVoiceOver: boolean;
  context: { [key: string]: any };
  hintName: string;
  theme?: {[key: string]: any};
};

type ReviewSpotState = {
  isExpanded: boolean;
}
export class ReviewSpot extends React.Component<ReviewSpotProps, ReviewSpotState> {
  constructor(props: ReviewSpotProps) {
    super(props);

    this.state = {
      isExpanded: false
    };
  }

  static defaultProps = {
    isGeneral: false,
    isVoiceOver: false
  };

  toggle = (event: any) => {
    event.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  };

  closePopup = () => {
    this.setState({
      isExpanded: false
    });
  };

  render() {
    const { isExpanded } = this.state;
    const { isGeneral, context, hintName, isVoiceOver } = this.props;
    return (
      <ReviewWrapper isVoiceOver={isVoiceOver} isGeneral={isGeneral} isActive={isExpanded}>
        <Hint
          position={isGeneral ? 'top' : 'auto'}
          hintElements={
            isGeneral
              ? localize('[click to leave a general comment]')
              : localize('[click to leave a comment]')
          }
          hintName={hintName}
          isExpanded={!!hintName}
        >
          <Tooltip
            trigger={'manual'}
            open={isExpanded}
            onRequestClose={() => this.closePopup()}
            arrow={true}
            position={'right'}
            interactive
            tooltipTheme={'light'}
            html={
              <ReviewForm
                role="dialog"
                ariaModal={true}
                tabIndex={-1}
                isGeneral={isGeneral}
                context={context}
                closePopover={this.toggle}
                theme={this.props.theme}
              />
            }
          >
            <ToggleButton
              role="button"
              tabIndex={1}
              onClick={this.toggle}
              onKeyDown={event => {
                if (event.key === ` ` || event.key === 'Enter') {
                  this.toggle(event);
                }
              }}
              isActive={isExpanded}
              isGeneral={isGeneral}
            >
              <CommentIcon size={isGeneral ? 9 : 10} name={'comment'} />
              {isGeneral && (
                <ToggleButtonText>{localize('[leave general comments]')}</ToggleButtonText>
              )}
            </ToggleButton>
          </Tooltip>
        </Hint>
      </ReviewWrapper>
    );
  }
}

export default withTheme(ReviewSpot);
